import React, { useState } from "react";

export default function TermosDeUsoApp() {
    const CONTACT_EMAIL = "contato@lumi.com.br";

    return (
        <div className="min-vh-100 bg-white">
            <main className="d-flex flex-column gap-32" style={{ padding: 128 }}>
                <section>
                    <h2 className="tt-18 bold color-gray-09">Termos e Condições de Uso - Aplicativo Lumi</h2>
                </section>

                <section>
                    <p className="tt-18 color-gray-09">
                        Bem-vindo ao Lumi, um aplicativo destinado a oferecer diagnósticos de NR1, trilhas de conteúdo formativas e serviços de telepsicologia, atendendo tanto o público corporativo quanto final. Ao utilizar o Lumi, você concorda integralmente com estes Termos e Condições de Uso. Recomendamos a leitura
                        atenta deste documento antes de acessar ou utilizar qualquer funcionalidade da plataforma.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">1. Definições</h3>
                    <ul>
                        <p className="tt-18 color-gray-09">
                            • <span className="fw-semibold">Lumi:</span> Plataforma digital composta por aplicativo e serviços relacionados, destinada à realização de diagnósticos organizacionais (incluindo o diagnóstico NR1), trilhas de conhecimento e telepsicologia.
                        </p>
                        <p className="tt-18 color-gray-09">
                            • <span className="fw-semibold">Usuário:</span> Qualquer pessoa física ou jurídica que acessa ou utiliza o Lumi.
                        </p>
                        <p className="tt-18 color-gray-09">
                            • <span className="fw-semibold">Cliente corporativo:</span> Empresas que contratam o Lumi para uso interno ou para seus colaboradores.
                        </p>
                        <p className="tt-18 color-gray-09">
                            • <span className="fw-semibold">Cliente final:</span> Usuário pessoa física que utiliza o Lumi individualmente.
                        </p>
                        <p className="tt-18 color-gray-09">
                            • <span className="fw-semibold">Telepsicologia:</span> Atendimento psicológico remoto realizado por profissionais habilitados.
                        </p>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">2. Aceitação dos Termos</h3>
                    <p className="tt-18 color-gray-09">
                        Ao acessar, criar uma conta ou utilizar os serviços do Lumi, <span className="fw-semibold">o Usuário declara ter lido, compreendido e aceitado plenamente estes Termos e Condições, além da Política de Privacidade disponível na plataforma.</span>
                    </p>
                    <p className="tt-18 color-gray-09">Caso não concorde com qualquer dispositivo aqui previsto, o Usuário deve interromper imediatamente o uso do Lumi.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">3. Descrição dos Serviços</h3>
                    <p className="tt-18 color-gray-09">O lumi oferece, dentro outros:</p>
                    <ol>
                        <p className="tt-18 color-gray-09">
                            <span className="fw-semibold">1. Diagnóstico de NR1:</span> Avaliação digital baseada nas diretrizes normativas vigentes, destinada a empresas e profissionais.
                        </p>
                        <p className="tt-18 color-gray-09">
                            <span className="fw-semibold">2. Trilhas de Conteúdo:</span> Materiais educativos e instrucionais relacionados a saúde, segurança, comportamento, gestão e desenvolvimento humano
                        </p>
                        <p className="tt-18 color-gray-09">
                            <span className="fw-semibold">3. Telepsicologia:</span> Sessões de atendimento remoto realizadas por psicólogos cadastrados no Conselho Federal de Psicologia, conforme regulamentação vigente.
                        </p>
                        <p className="tt-18 color-gray-09">
                            <span className="fw-semibold">4. Painéis e Relatórios:</span> Para empresas (B2B), disponibilização de dashboards, métricas e relatórios sobre os colaboradores participantes. O Lumi poderá adicionar, remover ou atualizar funcionalidades a qualquer momento, visando melhorias ou adequações
                            legais.
                        </p>
                    </ol>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">4. Cadastro e Conta do Usuário</h3>
                    <p className="tt-18 color-gray-09">Para utilizar o Lumi, o Usuário deverá:</p>
                    <ul>
                        <p className="tt-18 color-gray-09">• Fornecer informações verdadeiras, completas e atualizadas;</p>
                        <p className="tt-18 color-gray-09">• Ser maior de 18 anos ou possuir autorização legal e supervisão responsável;</p>
                        <p className="tt-18 color-gray-09">• Manter login e senha sob sigilo;</p>
                        <p className="tt-18 color-gray-09">• Notificar o Lumi em caso de uso não autorizado.</p>
                        <p className="tt-18 color-gray-09 mt-3">O Lumi poderá suspender ou encerrar contas que violem estes termos.</p>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">5. Obrigações do Usuário</h3>
                    <p className="tt-18 color-gray-09">O Usuário concorda em:</p>
                    <ul>
                        <p className="tt-18 color-gray-09">• Utilizar o Lumi de forma ética e dentro da legislação vigente;</p>
                        <p className="tt-18 color-gray-09">• Não realizar engenharia reversa, cópia ou distribuição indevida do sistema;</p>
                        <p className="tt-18 color-gray-09">• Não praticar atos fraudulentos ou que prejudiquem outros Usuários;</p>
                        <p className="tt-18 color-gray-09">• Respeitar as normas profissionais dos serviços oferecidos (ex.: telepsicologia)</p>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">6. Serviços de Telepsicologia</h3>

                    <h4 className="tt-18 bold color-gray-09">6.1 Credenciamento</h4>
                    <p className="tt-18 color-gray-09">Os atendimentos são realizados exclusivamente por psicólogos autorizados e registrados nos Conselhos Regionais de Psicologia.</p>

                    <h4 className="tt-18 bold color-gray-09">6.2 Responsabilidade Profissional</h4>
                    <p className="tt-18 color-gray-09">O Lumi atua como plataforma de conexão, não sendo responsável:</p>
                    <ul>
                        <p className="tt-18 color-gray-09">• Pelo conteúdo das sessões;</p>
                        <p className="tt-18 color-gray-09">• Por decisões clínicas;</p>
                        <p className="tt-18 color-gray-09">• Pela relação contratual entre paciente e profissional.</p>
                    </ul>

                    <h4 className="tt-18 bold color-gray-09">6.3 Limitações</h4>
                    <p className="tt-18 color-gray-09">A telepsicologia não substitui atendimentos de urgência, crises graves ou situações que demandem intervenção presencial imediata.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">7. Propriedade Intelectual</h3>
                    <p className="tt-18 color-gray-09">
                        Todo o conteúdo disponibilizado no Lumi (marca, interface, textos, trilhas, relatórios, algoritmos, diagnósticos e demais elementos) é protegido por leis de propriedade intelectual. O Usuário não adquire qualquer direito sobre tais materiais, exceto o uso limitado conforme previsto neste
                        documento.
                    </p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">8. Privacidade e Proteção de Dados</h3>
                    <p className="tt-18 color-gray-09">O Lumi coleta e trata dados pessoais conforme a LGPD - Lei Geral de Proteção de Dados (Lei nº 13.709/2018). Para detalhes completos sobre coleta, uso, armazenamento e compartilhamento de dados, consulte nossa Política de Privacidade.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">9. Pagamentos e Assinaturas</h3>
                    <p className="tt-18 color-gray-09">O acesso a determinadas funcionalidades pode exigir pagamento ou assinatura.</p>

                    <h4 className="tt-18 bold color-gray-09">9.1 Clientes corporativos</h4>
                    <p className="tt-18 color-gray-09">• Pagamentos mediante contrato comercial.</p>
                    <p className="tt-18 color-gray-09">• Relatórios e acessos conforme licenciamento adquirido.</p>

                    <h4 className="tt-18 bold color-gray-09">9.2 Usuários finais</h4>
                    <p className="tt-18 color-gray-09">• Planos mensais, semestrais ou anuais conforme oferta vigente.</p>
                    <p className="tt-18 color-gray-09">• Cancelamentos seguem regras do Código de Defesa do Consumidor.</p>

                    <h4 className="tt-18 bold color-gray-09">9.3 Reajustes</h4>
                    <p className="tt-18 color-gray-09">O Lumi poderá reajustar preços mediante aviso prévio.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">10. Limitações de Responsabilidade</h3>
                    <h4 className="tt-18 bold color-gray-09">O Lumi não se responsabiliza por:</h4>
                    <p className="tt-18 color-gray-09">• Decisões tomadas com base em diagnósticos ou relatórios;</p>
                    <p className="tt-18 color-gray-09">• Perdas indiretas, lucros cessantes ou danos decorrentes do uso inadequado da plataforma;</p>
                    <p className="tt-18 color-gray-09">• Problemas causados por indisponibilidade temporária, eventos de força maior ou falhas externas (internet, serviços de terceiros, etc.).</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">11. Atualizações dos Termos</h3>
                    <p className="tt-18 color-gray-09">O Lumi poderá atualizar estes Termos a qualquer momento, mediante aviso na plataforma. O uso contínuo após a atualização implica concordância com a nova versão.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">12. Cancelamento e Encerramento</h3>
                    <p className="tt-18 color-gray-09">O Usuário poderá cancelar sua conta a qualquer momento. O Lumi poderá encerrar contas que:</p>
                    <ul>
                        <p className="tt-18 color-gray-09">• violem estes Termos;</p>
                        <p className="tt-18 color-gray-09">• apresentem risco de segurança;</p>
                        <p className="tt-18 color-gray-09">• utilizem a plataforma de forma irregular.</p>
                    </ul>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">13. Legislação Aplicável</h3>
                    <p className="tt-18 color-gray-09">Estes Termos são regidos pelas leis brasileiras. Eventuais disputas serão resolvidas no foro da comarca de Porto Alegre/RS, salvo disposição contratual em contrário para clientes corporativos.</p>
                </section>

                <section>
                    <h3 className="tt-18 bold color-gray-09">14. Contato</h3>
                    <p className="tt-18 color-gray-09">Dúvidas, solicitações ou reclamações podem ser enviadas para:</p>
                    <p className="tt-18 color-gray-09">
                        E-mail: <span className="fw-semibold">{CONTACT_EMAIL}</span>
                    </p>
                    <p className="tt-18 color-gray-09">Ao utilizar o Lumi, você confirma seu aceite irrestrito destes Termos e Condições de Uso.</p>
                </section>
            </main>
        </div>
    );
}
